const ALL_PERMISSIONS = "AllPermissions";

export default {
  ALL_PERMISSIONS,
  defaultPermissions: {
    Retailer: [ALL_PERMISSIONS],
  },
  filters: [{ text: "Search", operation: "" }, { groupBy: "Role" }],
  pageSize: 24,
  orderBy: "-LastLogInAttempt,Id",
  sortOptions: {
    Sku: "Item Number: Low to High",
    "-Sku": "Item Number: High to Low",
    CompanyName: "CompanyName",
    "-CompanyName": "CompanyName",
    Cost: "Cost: Low to High",
    "-Cost": "Cost: High to Low",
    "LastLogInAttempt,Sku": "Created: Newest",
    "-LastLogInAttempt,Sku": "Created: Oldest",
    Active: "Active",
    "-Active": "Inactive",
  },
};
